import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["option", "details", "error", "radio"];
  static values  = { default: String, selected: String, updateQcConfirmMessage: String, currentRoute: String };

  connect() {
    const def = this.defaultValue || "internal_qc_lite";
    this.selectByValue(def);
  }

  select(event) {
    const el = event.currentTarget;
    const val = el?.dataset?.value;
    if (val) this.selectByValue(val);
    this.clearError();
  }

  selectByValue(value) {
    this.optionTargets.forEach((btn) => {
      const isSelected = btn.dataset.value === value;
      btn.classList.toggle("border-brand-1000", isSelected);
      btn.classList.toggle("border-black-100", !isSelected);
      btn.setAttribute("aria-pressed", isSelected ? "true" : "false");
    });

    this.selectedValue = value;

    const showDetails = value === "internal_qc_lite";
    if (this.hasDetailsTarget) {
      this.detailsTarget.classList.toggle("hidden", !showDetails);
    }
  }

  async confirm(event) {
    const button = event.currentTarget;
    button.disabled = true;

    let selectedValue = this.selectedValue;
    let formType = null;

    if (selectedValue === 'internal_qc_lite') {
      const internalQcRadio = this.radioTargets.find(radio => radio.checked);
      if (!internalQcRadio) {
        this.showError('Please select an Internal QC option');
        button.disabled = false;
        return;
      }
      formType = internalQcRadio.value;
      selectedValue = 'internal';
    } else if (selectedValue === 'manual_external_qc') {
      selectedValue = 'external';
    }

    const qcRouteInput = document.getElementById('qc_route_input');
    if (qcRouteInput) {
      qcRouteInput.value = selectedValue;
    }

    const formTypeInput = document.getElementById('form_type_input');
    if (formTypeInput) {
      if (formType) {
        formTypeInput.value = formType;
      } else if (!formTypeInput.value) {
        formTypeInput.value = 'internal_qc_lite'; // fallback to default type
      }
    }

    const form = document.getElementById('qc-route-form');
    if (form) {
      const routeChanged = this.currentRouteValue !== selectedValue;
      if (this.updateQcConfirmMessageValue && routeChanged) {
        const confirmController = this.application.getControllerForElementAndIdentifier(
          document.querySelector('[data-controller~="confirm"]'),
          'confirm',
        );
        const ok = await confirmController.request({ message: this.updateQcConfirmMessageValue });

        if (ok) {
          form.requestSubmit();
        } else {
          button.disabled = false;
        }
      } else {
        form.requestSubmit();
      }
    } else {
      button.disabled = false;
    }
  }

  showError(message) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = message;
      this.errorTarget.classList.remove('hidden');
    }
  }

  clearError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add('hidden');
    }
  }
}
